import React, { useState, useEffect } from 'react';
import { FaArrowRight, FaLongArrowAltRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';



const BRAND = '#a20000';
const BRAND_LIGHT = '#fdf2f2';

function useMediaQuery(query) {
    const [matches, setMatches] = useState(false);
    useEffect(() => {
        const mq = window.matchMedia(query);
        setMatches(mq.matches);
        const handler = (e) => setMatches(e.matches);
        mq.addEventListener('change', handler);
        return () => mq.removeEventListener('change', handler);
    }, [query]);
    return matches;
}

export default function CellIntroSection() {
    const isMobile = useMediaQuery('(max-width: 768px)');

    return (
        <section style={{
            padding: isMobile ? '48px 16px' : '80px 20px',
            background: '#fff',
            fontFamily: "'Segoe UI', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, sans-serif",
        }}>
            <div style={{ maxWidth: '1100px', margin: '0 auto' }}>

                {/* --- Top Header --- */}
                <div style={{ textAlign: 'center', marginBottom: isMobile ? '32px' : '48px' }}>
                    <h2 style={{
                        fontSize: isMobile ? '28px' : '42px',
                        fontWeight: 800,
                        color: '#1a1a1a',
                        margin: '0 0 12px 0',
                        letterSpacing: '-0.5px',
                    }}>
                        SOLAR <span style={{ color: BRAND }}>CELLS</span>
                    </h2>
                    <p style={{
                        fontSize: isMobile ? '14px' : '17px',
                        color: '#666',
                        maxWidth: '600px',
                        margin: '0 auto',
                        lineHeight: 1.6,
                    }}>
                        High-efficiency N-Type TOPCon cells engineered for superior performance and reliability.
                    </p>
                </div>

                {/* --- White Card Container --- */}
                <div style={{
                    background: '#fff',
                    borderRadius: '24px',
                    boxShadow: '0 10px 40px rgba(0,0,0,0.06)',
                    border: '1px solid #f0f0f0',
                    padding: isMobile ? '32px 20px' : '56px 48px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}>

                    {/* --- Badge --- */}
                    <div style={{
                        background: BRAND,
                        color: '#fff',
                        borderRadius: '30px',
                        padding: '6px 20px',
                        fontSize: isMobile ? '11px' : '13px',
                        fontWeight: 700,
                        letterSpacing: '1.5px',
                        textTransform: 'uppercase',
                        marginBottom: '20px',
                    }}>
                        Product Overview
                    </div>

                    {/* --- Inner Title --- */}
                    <h3 style={{
                        fontSize: isMobile ? '22px' : '32px',
                        fontWeight: 800,
                        color: '#1a1a1a',
                        margin: '0 0 32px 0',
                        textAlign: 'center',
                    }}>
                        G12R N-Type TOPCon Bifacial Cell
                    </h3>

                    {/* --- Product Image Placeholder --- */}
                    {/* Replace this div with your actual <img> tag */}
                    <div style={{
                        width: '100%',
                        maxWidth: '600px',
                        height: isMobile ? '240px' : '340px',
                        background: '#f8f8f8',
                        borderRadius: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: '40px',
                        border: '1px solid #eee',
                        overflow: 'hidden',
                    }}>
                        <img src="/cell-1.webp" alt="G12R Solar Cell" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />

                    </div>

                    {/* --- Bullet Points (Two Columns) --- */}
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
                        gap: isMobile ? '16px' : '24px 48px',
                        width: '100%',
                        maxWidth: '900px',
                        marginBottom: '48px',
                    }}>
                        {[
                            'High conversion efficiency with advanced N-Type TOPCon technology.',
                            'Bifacial dual-glass design for higher rear-side energy yield.',
                            'Optimized rectangular wafer format for improved module packing density.',
                            'Low temperature coefficient ensures stable performance in high temperatures.',
                        ].map((text, i) => (
                            <div key={i} style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: '12px',
                            }}>
                                <div style={{
                                    color: BRAND,
                                    fontSize: '16px',
                                    marginTop: '2px',
                                    flexShrink: 0,
                                }}>
                                    <FaLongArrowAltRight />
                                </div>
                                <span style={{
                                    fontSize: isMobile ? '14px' : '15px',
                                    color: '#555',
                                    lineHeight: 1.5,
                                }}>{text}</span>
                            </div>
                        ))}
                    </div>

                    {/* --- CTA Button --- */}
                    {/* <Link to='/solar-cell' style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '10px',
                        background: BRAND,
                        color: '#fff',
                        padding: isMobile ? '14px 32px' : '16px 40px',
                        borderRadius: '8px',
                        fontWeight: 700,
                        fontSize: isMobile ? '15px' : '17px',
                        textDecoration: 'none',
                        transition: 'background 0.3s, transform 0.2s',
                        boxShadow: '0 4px 14px rgba(162, 0, 0, 0.3)',
                    }}>
                        Explore G12R Cells <FaArrowRight />
                    </Link> */}

                </div>
            </div>
        </section>
    );
}